import React from 'react';
import { Star, ArrowRight, Plug, Smartphone, Zap } from 'lucide-react';
import { IMAGES } from '../mock';
import { useI18n } from '../i18n/I18nProvider';
import SignUpLink from './SignUpLink';

export default function Hero({ cms }) {
  const { t } = useI18n();
  const h = cms || {};
  const eyebrow = h.eyebrow || t('hero.eyebrow');
  const title = h.title || t('hero.title');
  const description = h.description || t('hero.description');
  const ctaPrimary = h.cta_primary || t('hero.ctaPrimary');
  const ctaSecondary = h.cta_secondary || t('hero.ctaSecondary');
  const badgeRating = h.badge_rating || t('hero.badgeRating');

  const TRUST_ITEMS = [
    { icon: Plug, label: t('hero.trustEasy') },
    { icon: Smartphone, label: t('hero.trustMobile') },
    { icon: Zap, label: t('hero.trustFast') },
  ];

  return (
    <section className="relative bg-pastel-hero pt-32 pb-20 md:pt-40 md:pb-24 overflow-hidden">
      <div className="mx-auto max-w-4xl px-5 text-center relative z-10">
        <div className="inline-flex items-center gap-2 rounded-full bg-white/80 backdrop-blur border border-black/5 pl-2 pr-4 py-1.5 shadow-sm">
          <span className="h-6 w-6 rounded-full bg-[#0b0b0f] text-white text-[11px] font-bold flex items-center justify-center">b</span>
          <span className="text-sm font-semibold text-[#0b0b0f]">{badgeRating}</span>
          <span className="flex items-center gap-0.5">
            {[0, 1, 2, 3, 4].map((i) => <Star key={i} size={13} className="fill-[#f5b301] text-[#f5b301]" />)}
          </span>
        </div>

        <p className="mt-7 text-sm font-semibold text-[#76B828] tracking-wide">{eyebrow}</p>
        <h1 className="font-display text-[2.6rem] leading-[1.05] sm:text-6xl md:text-[4.2rem] mt-3 text-[#0b0b0f]">
          {title}
        </h1>
        <p className="mt-6 text-lg text-[#55555f] max-w-2xl mx-auto leading-relaxed">
          {description}
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <SignUpLink className="btn-pill btn-brand px-7 py-3.5 text-[15px] w-full sm:w-auto">
            {ctaPrimary}
          </SignUpLink>
          <a href="#features" className="btn-pill btn-light px-7 py-3.5 text-[15px] w-full sm:w-auto group">
            {ctaSecondary} <ArrowRight size={17} className="group-hover:translate-x-1 transition-transform" />
          </a>
        </div>

        <div className="mt-7 flex flex-wrap items-center justify-center gap-x-7 gap-y-2">
          {TRUST_ITEMS.map((item) => (
            <span key={item.label} className="flex items-center gap-2 text-sm text-[#55555f]">
              <item.icon size={16} className="text-[#0b0b0f]" /> {item.label}
            </span>
          ))}
        </div>
      </div>

      <div className="mx-auto max-w-5xl px-5 mt-14 relative z-10">
        <div className="relative rounded-[1.75rem] overflow-hidden border border-black/5 shadow-[0_40px_120px_rgba(15,15,20,0.22)] bg-white">
          <img src={IMAGES.heroShowcase} alt={t('hero.imageAlt')} className="w-full h-[300px] md:h-[460px] object-cover" />
          <div className="absolute left-4 bottom-4 md:left-8 md:bottom-8 bg-white/95 backdrop-blur rounded-2xl shadow-xl border border-black/5 p-4 md:p-5 w-[230px] md:w-[280px]">
            <p className="text-xs font-semibold uppercase tracking-wider text-[#8b8b95]">{t('hero.cardEyebrow')}</p>
            <div className="mt-3 space-y-2.5">
              <div className="flex items-center justify-between text-sm"><span className="text-[#6b6b73]">{t('hero.guests')}</span><span className="font-semibold text-[#0b0b0f]">{t('hero.guestsValue')}</span></div>
              <div className="flex items-center justify-between text-sm"><span className="text-[#6b6b73]">{t('hero.date')}</span><span className="font-semibold text-[#0b0b0f]">{t('hero.dateValue')}</span></div>
              <div className="flex items-center justify-between text-sm"><span className="text-[#6b6b73]">{t('hero.table')}</span><span className="font-semibold text-[#0b0b0f]">{t('hero.tableValue')}</span></div>
            </div>
            <div className="mt-3 rounded-lg bg-[#e9f9f0] text-[#16a34a] text-xs font-semibold py-2 text-center">{t('hero.confirmed')}</div>
          </div>
        </div>
      </div>
    </section>
  );
}
